import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Paper } from '@dev/ee-components';

import { GetAllCheckoutsStart, UnpickAllCheckouts } from '@/store/checkouts/actions';
import useMobile from '@/services/hooks/useMobile';
import CheckoutsDraftsTable from './components/CheckoutsDraftsTable';
import { MobileDraftsTable } from './components/MobileDraftTable';
import MobileFiltersComponent from './components/MobileFilters';
import { useCheckoutParamsFromUrl } from '../hooks/useRequestParams';
import { CustomPagination } from '../CheckoutsList/components/CustomPagination';

export const CheckoutDraftsList = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const requestParams = useCheckoutParamsFromUrl();

    useEffect(() => {
        dispatch(GetAllCheckoutsStart(requestParams));
        return () => {
            dispatch(UnpickAllCheckouts());
        };
    }, []);

    if (isMobile) {
        return (
            <>
                <MobileFiltersComponent />
                <MobileDraftsTable />
                <CustomPagination />
            </>
        );
    }

    return (
        <Paper margin={{ top: 32 }}>
            <CheckoutsDraftsTable />
            <CustomPagination />
        </Paper>
    );
};

